import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-doc-link',
  templateUrl: './doc-link.component.html',
  styleUrls: ['./doc-link.component.scss']
})
export class DocLinkComponent {
  @Input() url: string | undefined;
  @Input() tooltip: string = 'Clique para acessar a documentação';
  @Input() base: string = 'https://docs.rhgestao.com';
  @Input() company: string | undefined;
  @Input() openLogin: boolean = false;
 
  get href(): string | undefined {
    if (this.openLogin) return this.buildLoginHref();
    if (!this.url) return undefined;
    return this.isAbsoluteUrl(this.url) ? this.buildAbsoluteHref() : this.buildRelativeHref();
  }

  private isAbsoluteUrl(value: string): boolean {
    return /^https?:\/\//i.test(value);
  }

  private appendQueryParam(target: string, key: string, value: string): string {
    const sep = target.includes('?') ? '&' : '?';
    return `${target}${sep}${key}=${encodeURIComponent(value)}`;
  }
  private appendFragmentParams(target: string, params: URLSearchParams): string {
    const fragment = params.toString();
    if (!fragment) return target;
    const parts = target.split('#');
    const beforeHash = parts[0];
    const afterHash = parts[1] || '';
    if (afterHash) {
      return `${beforeHash}#${afterHash}&${fragment}`;
    }
    return `${beforeHash}#${fragment}`;
  }

  private buildLoginHref(): string {
    const loginBase = (this.base || '').replace(/\/+$|\s+$/g, '') + '/login';
    const params = new URLSearchParams();
    if (this.company) params.set('company', this.company);

    if (this.url) {
      const suffix = this.url.replace(/^\/+/, '');
      params.set('redirect', `/demo/${suffix}`);
    }

    return this.appendFragmentParams(loginBase, params);
  }

  private buildAbsoluteHref(): string {
    let href = this.url as string;
    if (this.company) {
      const params = new URLSearchParams();
      params.set('company', this.company);
      href = this.appendFragmentParams(href, params);
    }

    return href;
  }

  private buildRelativeHref(): string {
    const base = (this.base || '').replace(/\/+$|\s+$/g, '');
    const suffix = (this.url || '').replace(/^\/+/, '');
    let href = `${base}/${suffix}`;
    if (this.company) {
      const params = new URLSearchParams();
      params.set('company', this.company);
      href = this.appendFragmentParams(href, params);
    }

    return href;
  }
}
